var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from "classnames";
import { forwardRef, useRef, } from "react";
import mergeRefs from "react-merge-refs";
import s from "./Button.module.css";
var Button = forwardRef(function (props, buttonRef) {
    var _a;
    var className = props.className, _b = props.primary, primary = _b === void 0 ? false : _b, children = props.children, width = props.width, _c = props.type, type = _c === void 0 ? "button" : _c, _d = props.loading, loading = _d === void 0 ? false : _d, _e = props.active, active = _e === void 0 ? false : _e, _f = props.disabled, disabled = _f === void 0 ? false : _f, _g = props.rounded, rounded = _g === void 0 ? false : _g, _h = props.style, style = _h === void 0 ? {} : _h, _j = props.Component, Component = _j === void 0 ? "button" : _j, rest = __rest(props, ["className", "primary", "children", "width", "type", "loading", "active", "disabled", "rounded", "style", "Component"]);
    var ref = useRef(null);
    var rootClassName = cn(s.root, (_a = {},
        _a[s.primary] = primary,
        _a[s.active] = active,
        _a[s.loading] = loading,
        _a[s.disabled] = disabled,
        _a[s.rounded] = rounded,
        _a), className);
    return (_jsx(Component, __assign({ ref: mergeRefs([ref, buttonRef]), type: type, className: rootClassName, disabled: disabled, style: __assign({ width: width }, style) }, rest, { children: children }), void 0));
});
export default Button;
